import React, { Component } from "react";
import { FiCheck } from "react-icons/fi";
import PageHelmet from "../../component/common/Helmet";
import ModalVideo from 'react-modal-video';
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../../component/header/Header";
import Footer from "../../component/footer/FooterTwo";
import Breadcrumb from "../../elements/common/Breadcrumb";


class ServiceDetails extends Component {
    constructor() {
        super()
        this.state = {
            isOpen: false,
            isOpen1: false,
            isOpen2: false,
            isOpen3: false,
            isOpen4: false,
            isOpen5: false,
        }
        this.openModal = this.openModal.bind(this)
        this.openModal1 = this.openModal1.bind(this)
        this.openModal2 = this.openModal2.bind(this)
        this.openModal3 = this.openModal3.bind(this)
        this.openModal4 = this.openModal4.bind(this)
        this.openModal5 = this.openModal5.bind(this)
    }
    openModal() {
        this.setState({ isOpen: true })
    }
    openModal1() {
        this.setState({ isOpen1: true })
    }
    openModal2() {
        this.setState({ isOpen2: true })
    }
    openModal3() {
        this.setState({ isOpen3: true })
    }
    openModal4() {
        this.setState({ isOpen4: true })
    }
    openModal5() {
        this.setState({ isOpen5: true })
    }
    render() {
        return (
            <React.Fragment>

                {/* Start Pagehelmet  */}
                <PageHelmet pageTitle='Videos' />
                {/* End Pagehelmet  */}

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />

                {/* Start Breadcrump Area */}
                <Breadcrumb title={'Videos'} />
                {/* End Breadcrump Area */}

                {/* Start Page Wrapper */}
                <div className="rn-service-details ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="service-details-inner">
                                    <div className="inner">
                                        {/* Start Single Area */}
                                        <div className="row row--35 sercice-details-content align-items-center">
                                            <div className="col-lg-12 col-12">
                                                <div className="details mt_md--30 mt_sm--30">
                                                    <div className="section-title">
                                                        <h2 className="title">Launch of the Innovation Community on Affordable Heating and Cooling of Buildings:</h2>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-12 col-12 mt-4">
                                                <div className="thumb position-relative">
                                                    <img className="w-100" src="/assets/images/bg/bg-image-19.jpg" alt="Service Images" />
                                                    <ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId='OpqILF6w6lU' onClose={() => this.setState({ isOpen: false })} />
                                                    <button className="video-popup" onClick={this.openModal}><span className="play-icon"></span></button>
                                                </div>
                                            </div>
                                        </div>
                                        {/* End Single Area */}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Page Wrapper */}

                {/* Start Page Wrapper */}
                <div className="rn-service-details ptb--120 bg_color--3">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="service-details-inner">
                                    <div className="inner">
                                        {/* Start Single Area */}
                                        <div className="row row--35 sercice-details-content align-items-center">
                                            <div className="col-lg-12 col-12">
                                                <div className="details mt_md--30 mt_sm--30">
                                                    <div className="section-title">
                                                        <h2 className="title">Air conditioning and cooling - Perspectives from India:</h2>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-12 col-12 mt-4">
                                                <div className="thumb position-relative">
                                                    <img className="w-100" src="/assets/images/bg/bg-image-21.jpg" alt="Service Images" />
                                                    <ModalVideo channel='youtube' isOpen={this.state.isOpen1} videoId='f5kFPsIjUJg' onClose={() => this.setState({ isOpen1: false })} />
                                                    <button className="video-popup" onClick={this.openModal1}><span className="play-icon"></span></button>
                                                </div>
                                            </div>
                                        </div>
                                        {/* End Single Area */}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Page Wrapper */}

                {/* Start Page Wrapper */}
                <div className="rn-service-details ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="service-details-inner">
                                    <div className="inner">
                                        {/* Start Single Area */}
                                        <div className="row row--35 sercice-details-content align-items-center">
                                            <div className="col-lg-12 col-12">
                                                <div className="details mt_md--30 mt_sm--30">
                                                    <div className="section-title">
                                                        <h2 className="title">Launch of ‘Beating the Heat’ Sustainable Cooling handbook for Cities, Nov 2021:</h2>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-12 col-12 mt-4">
                                                <div className="thumb position-relative">
                                                    <img className="w-100" src="/assets/images/bg/bg-image-22.jpg" alt="Service Images" />
                                                    <ModalVideo channel='youtube' isOpen={this.state.isOpen2} videoId='OqMpbL1dnX0' onClose={() => this.setState({ isOpen2: false })} />
                                                    <button className="video-popup" onClick={this.openModal2}><span className="play-icon"></span></button>
                                                </div>
                                            </div>
                                        </div>
                                        {/* End Single Area */}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Page Wrapper */}

                {/* Start Page Wrapper */}
                <div className="rn-service-details ptb--120 bg_color--3">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="service-details-inner">
                                    <div className="inner">
                                        {/* Start Single Area */}
                                        <div className="row row--35 sercice-details-content align-items-center">
                                            <div className="col-lg-12 col-12">
                                                <div className="details mt_md--30 mt_sm--30">
                                                    <div className="section-title">
                                                        <h2 className="title">Comfort Climate Box:</h2>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-12 col-12 mt-4">
                                                <div className="thumb position-relative">
                                                    <img className="w-100" src="/assets/images/bg/bg-image-23.jpg" alt="Service Images" />
                                                    <ModalVideo channel='youtube' isOpen={this.state.isOpen3} videoId='fe3xs_aK1DA' onClose={() => this.setState({ isOpen3: false })} />
                                                    <button className="video-popup" onClick={this.openModal3}><span className="play-icon"></span></button>
                                                </div>
                                            </div>
                                        </div>
                                        {/* End Single Area */}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Page Wrapper */}

                {/* Start Page Wrapper */}
                <div className="rn-service-details ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="service-details-inner">
                                    <div className="inner">
                                        {/* Start Single Area */}
                                        <div className="row row--35 sercice-details-content align-items-center">
                                            <div className="col-lg-12 col-12">
                                                <div className="details mt_md--30 mt_sm--30">
                                                    <div className="section-title">
                                                        <h2 className="title">Global Cooling Prize:</h2>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-12 col-12 mt-4">
                                                <div className="thumb position-relative">
                                                    <img className="w-100" src="/assets/images/bg/bg-image-13.jpg" alt="Service Images" />
                                                    <ModalVideo channel='youtube' isOpen={this.state.isOpen4} videoId='3_IwemPA2M4' onClose={() => this.setState({ isOpen4: false })} />
                                                    <button className="video-popup" onClick={this.openModal4}><span className="play-icon"></span></button>
                                                </div>
                                            </div>
                                        </div>
                                        {/* End Single Area */}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Page Wrapper */}

                {/* Start Page Wrapper */}
                <div className="rn-service-details ptb--120 bg_color--3">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="service-details-inner">
                                    <div className="inner">
                                        {/* Start Single Area */}
                                        <div className="row row--35 sercice-details-content align-items-center">
                                            <div className="col-lg-12 col-12">
                                                <div className="details mt_md--30 mt_sm--30">
                                                    <div className="section-title">
                                                        <h2 className="title">MI IC7 Deep Dive workshop Nov 6,New Delhi:</h2>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-12 col-12 mt-4">
                                                <div className="thumb position-relative">
                                                    <img className="w-100" src="/assets/images/bg/bg-image-20.jpg" alt="Service Images" />
                                                    <ModalVideo channel='youtube' isOpen={this.state.isOpen5} videoId='CnQvPyI2jvU' onClose={() => this.setState({ isOpen5: false })} />
                                                    <button className="video-popup" onClick={this.openModal5}><span className="play-icon"></span></button>
                                                </div>
                                            </div>
                                        </div>
                                        {/* End Single Area */}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Page Wrapper */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}

                <Footer />

            </React.Fragment>
        )
    }
}
export default ServiceDetails;